export default "__VITE_ASSET__1Pr9CjGb__"